// @flow

import React from 'react';
import PropTypes from 'prop-types';
import ProjectContentDescription from '../ContentDescription';
import Tooltip from '../../../../../Resources/Common/Tooltip';

export default function Competition(props) {
  const { proposalUid, blocked, hasRights } = props;
  return (
    <ProjectContentDescription
      title="La concurrence"
      tooltip={Tooltip.ProjectOfferCompetition.description}
      proposalUid={proposalUid}
      blocked={blocked}
      hasRights={hasRights}
    />
  );
}

Competition.propTypes = {
  hasRights: PropTypes.bool.isRequired,
  blocked: PropTypes.bool.isRequired,
  proposalUid: PropTypes.string
};

Competition.defaultProps = {
  proposalUid: undefined
};
